module.exports = __webpack_public_path__ + "img/13.e1b95f1f.png";